/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { InvoiceRequest as BackendCoreApiModelsAppInvoiceInvoiceRequest } from '../models/Backend/Core/Api/Models/App/Invoice/invoice-request';
import { InvoiceResponse as BackendCoreApiModelsAppInvoiceInvoiceResponse } from '../models/Backend/Core/Api/Models/App/Invoice/invoice-response';

@Injectable({
  providedIn: 'root',
})
export class AppInvoicesBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getInvoices
   */
  static readonly GetInvoicesPath = '/api/app/invoice/invoices';

  /**
   * Gets invoices.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoices$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getInvoices$Plain$Response(params: {
    body: BackendCoreApiModelsAppInvoiceInvoiceRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppInvoiceInvoiceResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppInvoicesBackendService.GetInvoicesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppInvoiceInvoiceResponse>;
      })
    );
  }

  /**
   * Gets invoices.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvoices$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getInvoices$Plain(params: {
    body: BackendCoreApiModelsAppInvoiceInvoiceRequest
  }): Observable<BackendCoreApiModelsAppInvoiceInvoiceResponse> {

    return this.getInvoices$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppInvoiceInvoiceResponse>) => r.body as BackendCoreApiModelsAppInvoiceInvoiceResponse)
    );
  }

  /**
   * Gets invoices.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoices$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getInvoices$Json$Response(params: {
    body: BackendCoreApiModelsAppInvoiceInvoiceRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppInvoiceInvoiceResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppInvoicesBackendService.GetInvoicesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppInvoiceInvoiceResponse>;
      })
    );
  }

  /**
   * Gets invoices.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvoices$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getInvoices$Json(params: {
    body: BackendCoreApiModelsAppInvoiceInvoiceRequest
  }): Observable<BackendCoreApiModelsAppInvoiceInvoiceResponse> {

    return this.getInvoices$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppInvoiceInvoiceResponse>) => r.body as BackendCoreApiModelsAppInvoiceInvoiceResponse)
    );
  }

}
